import React from 'react';

export default function HeroSection({ onGetStartedClick }) {
  return (
    <section className="relative h-[60vh] md:h-[80vh] flex items-center justify-center text-white">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{backgroundImage: "url('https://images.unsplash.com/photo-1576091160550-2173dba999ef?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')"}}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
      </div>
      <div className="relative z-10 text-center px-4">
        <h1 className="text-4xl md:text-6xl font-bold tracking-tight">
          Transform Your Pharma Sales Team
        </h1>
        <p className="mt-4 md:mt-6 max-w-2xl mx-auto text-lg md:text-xl text-gray-200">
          The all-in-one CRM for medical representatives. Streamline visits, manage doctors, track expenses, and boost performance with powerful analytics.
        </p>
        <div className="mt-8 md:mt-10">
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white text-lg px-8 py-4 rounded-lg font-semibold transition-colors"
            onClick={onGetStartedClick}
          >
            Request a Demo
          </button>
        </div>
      </div>
    </section>
  );
}
